export default [
  {
    route: 'users',
    title: 'users',
    icon: 'UserIcon',
    i18n: 'Users',
    rule: 'users.menu'
  },
  {
    route: 'roles',
    title: 'roles',
    icon: 'UsersIcon',
    i18n: 'Roles',
    rule: 'roles.menu'
  },
]
